import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import { fg } from '@atlaskit/platform-feature-flags';

import type { AIPlugin } from '../../../aiPluginType';

export const getAreAiEntryPointsDisabled = (api: ExtractInjectionAPI<AIPlugin> | undefined) =>
	fg('platform_editor_ai_toggle_entry_points')
		? (api?.aiExperience?.sharedState.currentState()?.areAiEntryPointsDisabled ?? false)
		: false;

export const useAreAiEntryPointsDisabled = (api: ExtractInjectionAPI<AIPlugin> | undefined) => {
	const { areAiEntryPointsDisabled } = useSharedPluginStateWithSelector(
		api,
		['aiExperience'],
		({ aiExperienceState }) => ({
			areAiEntryPointsDisabled: fg('platform_editor_ai_toggle_entry_points')
				? (aiExperienceState?.areAiEntryPointsDisabled ?? false)
				: false,
		}),
	);

	return areAiEntryPointsDisabled;
};
